"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accordionConfig = void 0;
var react_1 = __importDefault(require("react"));
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var slate_1 = require("slate");
var Heading2_1 = require("./Heading2");
var Paragraph_1 = require("./Paragraph");
var MakeConfig_1 = require("../Utils/MakeConfig");
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var AccordionWidgetToolbarButtons_1 = require("Project/QwilrEditor/Widgets/AccordionWidget/AccordionWidgetToolbarButtons");
var AccordionRegistryWidget_1 = require("Project/QwilrEditor/Widgets/AccordionWidget/AccordionRegistryWidget");
var Deserialise_1 = require("Project/QwilrEditor/Tokenization/Deserialise");
var Serialise_1 = require("Project/QwilrEditor/Tokenization/Serialise");
var Utils_1 = require("Project/QwilrEditor/Utils");
var lodash_1 = require("lodash");
var slate_react_1 = require("slate-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var constants_1 = require("../constants");
var TelemetryParameterValue_1 = require("@CommonFrontend/Telemetry/TelemetryParameterValue");
var AccordionRegistryContext_1 = require("Project/QwilrEditor/Widgets/AccordionWidget/AccordionRegistryContext");
var TokenizationErrorRecorder_1 = require("Project/QwilrEditor/Tokenization/TokenizationErrorRecorder");
var isVisualAccordion = function (blockStyleStore) {
    var accordionStyles = blockStyleStore.getElementStyle("accordion");
    return accordionStyles.cardStyle === BlockStyleTypes_1.AccordionWidgetCardStyle.Visual;
};
var createAccordionHeading = function () {
    return {
        isVoid: false,
        type: "accordionHeading",
        children: [(0, Heading2_1.createHeading2Node)()],
    };
};
var createAccordionBody = function () {
    return {
        isVoid: false,
        type: "accordionBody",
        children: [(0, Paragraph_1.createParagraphNode)()],
    };
};
var createEmptyAccordion = function () { return ({
    isVoid: false,
    type: "accordion",
    data: { expanded: false },
    children: [createAccordionHeading(), createAccordionBody()],
}); };
exports.accordionConfig = (0, MakeConfig_1.makeConfig)(__assign(__assign({}, (0, GetCommonConfigByType_1.getCommonConfigByType)("accordion")), { node: {}, nodeType: "layoutElement", toolbarButtons: AccordionWidgetToolbarButtons_1.AccordionWidgetToolbarButtons, editorRender: AccordionRegistryWidget_1.AccordionRegistryWidget, firstLastConfiguration: { isValidFirstChild: true }, width: "full-width", deserialise: function (token, content, commentTracker) {
        var _a;
        var bodyContent;
        if (token.body && token.body.length === 0) {
            (0, TokenizationErrorRecorder_1.sendEmptyLayoutToSentry)("accordion", "accordionBody", "deserialisation");
            bodyContent = { children: [(0, Paragraph_1.createParagraphNode)()] };
        }
        else {
            bodyContent = (0, Deserialise_1.deserialiseNode)(token.body, commentTracker);
        }
        var headingContent;
        if (((_a = token.heading) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            (0, TokenizationErrorRecorder_1.sendEmptyLayoutToSentry)("accordion", "accordionHeading", "deserialisation");
            headingContent = { children: [(0, Paragraph_1.createParagraphNode)()] };
        }
        else {
            headingContent = (0, Deserialise_1.deserialiseNode)(token.heading, commentTracker);
        }
        var node = {
            type: "accordion",
            children: [
                { type: "accordionHeading", isVoid: false, children: headingContent.children },
                {
                    type: "accordionBody",
                    isVoid: false,
                    children: bodyContent.children,
                },
            ],
            isVoid: false,
            data: {
                expanded: false,
                backgroundImageUrl: token.backgroundImageUrl,
            },
        };
        var extractSelectionFromChild = function (index, areaContent) {
            if (areaContent.selection) {
                node.key = "tempAccordionKey";
                var accordionPath = (0, Deserialise_1.getPathToNodeBasedOnKey)(node.key, content.children.concat(node));
                if (areaContent.selection.anchor.path) {
                    areaContent.selection.anchor.path = accordionPath.concat([index], areaContent.selection.anchor.path);
                }
                if (areaContent.selection.focus.path) {
                    areaContent.selection.focus.path = accordionPath.concat([index], areaContent.selection.focus.path);
                }
                if (content.selection) {
                    if (content.selection.anchor.path) {
                        content.selection.focus = areaContent.selection.focus;
                    }
                    else {
                        content.selection.anchor = areaContent.selection.anchor;
                    }
                }
                else {
                    content.selection = areaContent.selection;
                }
                delete node.key;
            }
        };
        extractSelectionFromChild(0, headingContent);
        extractSelectionFromChild(1, bodyContent);
        return node;
    }, serialise: function (node, editor, commentTracker, selection) {
        var children = node.children;
        var serialisedHeading = (0, Serialise_1.serialiseElements)(children[0].children, editor, commentTracker, selection);
        var serialisedBody = (0, Serialise_1.serialiseElements)(children[1].children, editor, commentTracker, selection);
        if (serialisedHeading.length === 0) {
            (0, TokenizationErrorRecorder_1.sendEmptyLayoutToSentry)("accordion", "accordionHeading", "serialisation");
        }
        if (serialisedBody.length === 0) {
            (0, TokenizationErrorRecorder_1.sendEmptyLayoutToSentry)("accordion", "accordionBody", "serialisation");
        }
        return [
            {
                type: "block",
                subType: "accordion",
                heading: serialisedHeading,
                body: serialisedBody,
                backgroundImageUrl: node.data.backgroundImageUrl,
            },
        ];
    }, onAddWidget: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var blockStyleStore, stockImagesService, accordion, _c, selection, path, currBlockEntry;
        var editor = _b.editor, di = _b.di;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    blockStyleStore = di.get("blockStore").blockStyleStore;
                    stockImagesService = di.get("stockImageService");
                    accordion = createEmptyAccordion();
                    if (!isVisualAccordion(blockStyleStore)) return [3, 2];
                    _c = accordion.data;
                    return [4, stockImagesService.getRandomImage({ preventBoringImages: true })];
                case 1:
                    _c.backgroundImageUrl = (_d.sent()).url;
                    _d.label = 2;
                case 2:
                    selection = editor.selection;
                    path = selection.anchor.path;
                    currBlockEntry = (0, Utils_1.getClosestBlock)(editor, path);
                    if (!currBlockEntry) {
                        return [2];
                    }
                    slate_1.Editor.withoutNormalizing(editor, function () {
                        slate_1.Transforms.removeNodes(editor, { at: currBlockEntry[1] });
                        slate_1.Transforms.insertNodes(editor, accordion, { at: currBlockEntry[1] });
                    });
                    slate_1.Transforms.select(editor, path);
                    (0, lodash_1.defer)(function () {
                        slate_react_1.ReactEditor.focus(editor);
                    });
                    return [2];
            }
        });
    }); }, validContainers: ["contentLoopBody"], validEditors: ["standard"], normalizeWidget: function (node, path, editor) {
        if (!node.children.length) {
            slate_1.Transforms.removeNodes(editor, { at: path });
            return true;
        }
        if (!node.children[0] || node.children[0].type !== "accordionHeading") {
            slate_1.Transforms.insertNodes(editor, createAccordionHeading(), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        if (!node.children[1] || node.children[1].type !== "accordionBody") {
            slate_1.Transforms.insertNodes(editor, createAccordionBody(), { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
            return true;
        }
        if (node.children.length > 2) {
            slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [2], false) });
            return true;
        }
        return false;
    }, widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.AccordionLeftButton, null),
        tags: ["accordion", "foldable", "toggle"],
        displayName: "Accordion",
        requiresFeatures: [FeatureFlag_1.default.Accordion],
        tooltip: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("img", __assign({ src: "Assets/Images/accordion-tooltip-preview.gif" }, constants_1.WIDGET_ADDER_ENTRY_TOOLTIP_PREVIEW_IMAGE_DIMENSIONS)),
            react_1.default.createElement("span", null, "Add foldable content within your blocks"))),
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.Accordion, containerNodeConfiguration: {
        showWidgetAdder: false,
        hasContainerManagedChildren: true,
    }, widgetContextProvider: AccordionRegistryContext_1.AccordionRegistryContextProvider }));
